import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MerchantService {
  private merchantStatusChange: Subject<String> = new Subject<String>();
  merchantStatus = this.merchantStatusChange.asObservable();

  constructor(private http: HttpClient) { }

  public getMerchantList(page:number,search:string, sort?:any) {
    let params = new HttpParams()
    if(sort) {
      params = params.set('sort',sort)
    }
   
    return this.http.get<any>(`mhvoucher/merchants?page=${page}&limit=10&search=${search}&${params}`
    // , {
    //   params: {
    //     page: page,
    //     limit: 10,
    //     search: search,
    //     sort: sort
    //   }
    // }
    );
  }
  public createMerchant(request: any):Observable<any> {
    return this.http.post('mhvoucher/merchants', request);
  }
  public getMerchantDetails(idpassed: string) {
    return this.http.get<any>('mhvoucher/merchants/' + idpassed + '?include=LOCATION')
  }
  public updateMerchant(request: any, idpassed:string) {
  
    return this.http.patch<any>('mhvoucher/merchants/', request, { 
      params: {
       id:idpassed
      } })
  }
  public updateLocation(request: any) {

    return this.http.patch<any>('mhvoucher/merchants/'+ request.merchant+'/locations/'+request.locationId, request.requestBody, { 
      params: {
        merchant:request.merchant,
        locationId:request.locationId
       } })
  }
  public deleteLocation(request: any) {
    return this.http.patch<any>('mhvoucher/merchants/'+ request.merchant+'/locations/'+request.locationId, request.requestBody, {
      params: {
        merchant:request.merchant,
        locationId:request.locationId
       }})
  }
  public createLocation(request: any) {
   
    return this.http.post<any>('mhvoucher/merchants/'+ request.merchant+'/locations',{
      data:request.requestBody
    } , { 
      params: {
        merchant:request.merchant
       } })
  }

  public setMerchantStatusChange(value:any){
    this.merchantStatusChange.next(value)
  }
}